var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info",class:_vm.size,style:(_vm.styles)},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.icon),expression:"icon"}],staticClass:"info__icon",attrs:{"src":_vm.icon,"alt":""},on:{"load":function($event){return _vm.resolveAsset($event)}}}),_c('span',{staticClass:"info__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }